import React, { useEffect } from 'react';
// import ObjectsReestrView from '../components/contents/ObjectsReestrView';
import ObjectsReestrView from '../components/contents/ObjectsReestrViewV2';

const ObjectsReestrPage = () => {

  useEffect(() => {
    document.title = "Реестр объектов";
}, []);

  return (
    <ObjectsReestrView />
  );
};

export default ObjectsReestrPage; 